import didYouMean from 'didyoumean2'

import { InsuranceType } from 'types/api.graphql'

export const guessInsuranceType = (
  input: string,
  customInsurancesTypes?: string[]
) => {
  const matchedInsuranceType = didYouMean(input, [
    InsuranceType.WorkCover.toString(),
    InsuranceType.PublicLiability.toString(),
    ...(customInsurancesTypes ?? []),
  ])

  return matchedInsuranceType
}
